<div class="container mt-3" id="container">
    <!-- <div data-html2canvas-ignore="true">
        <input type="button" value="CAPTURE" (click)="captureScreen()" />
    </div> -->
    <div data-size="A4" id="draftPdfPreview1">
        <div class="row" style="margin-top: -20px">
            <div class="col" id="title-container">
                <h2>{{translateLabel('deliveryPaperTitle')}}</h2>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
                <div class="card" style="height: 180px;">
                    <div class="card-body">
                        <strong class="text-uppercase" >{{translateLabel('supplierTitle')}}</strong>
                        <div class="card-text">
                          {{translateLabel('supplierName')}}<br />{{translateLabel('supplierAdress')}}<br />{{translateLabel('supplierCity')}}
                        </div>
                    </div>
                </div>
                <div class="card mt-1" style="height: 110px;">
                    <div class="card-body">
                        <div class="row" style="margin-top: -5px;">
                            <div class="col">
                                <strong class="text-uppercase">{{translateLabel('eventTitle')}}:</strong>
                                <div class="card-text">
                                    {{event.eventName}}
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 5px;">
                            <div class="col">
                                <strong class="text-uppercase">{{translateLabel('dateTitle')}}:</strong>
                                <div class="card-text">
                                    {{event.startDate | date:'dd-MM-yyyy'}} / {{event.endDate | date:'dd-MM-yyyy'}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card" style="height: 90px;">
                    <div class="card-body">
                        <strong class="text-uppercase">{{translateLabel('deliveryPaperTitle')}}</strong>
                        <div class="card-text">
                          {{translateLabel('deliveryPaperNr')}}: <input type="text" /> {{translateLabel('deliveryPaperDate')}} <input type="text" />
                        </div>
                    </div>
                </div>
                <div class="card mt-1" style="height: 200px;">
                    <div class="card-body">
                        <strong class="text-uppercase">{{translateLabel('customerTitle')}}</strong>
                        <div class="card-text">
                            {{event.clientUser.firstName}} {{event.clientUser?.lastName}}<br />
                            {{event.clientUser.company.name}}
                            <br /> {{event.clientUser.company.address}} <br /> I -
                            {{event.clientUser.company.postalCode}}
                            <br /> {{event.clientUser.company?.village?.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--
          Info: Phone hardware and software visualisation rules
          1) If all phones are rented I show the count of phones as“Smartphone“ and hide the count of waiter software (because phisical phone contain already software)
          2) If all phones are not rented I show only the count of software as “Kellner Software“
          3) If customer rents some phones and uses also some own phone I show the quantity of rented phones as“Smartphone“ and the difference of total quantity of software and the quantity rented phones as  “Kellner Software“.
        -->
        <div class="row mt-3">
            <div class="col">
                <table class="table table-bordered" style="margin-top: -12px">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-center" style="width: 70%; color:#000000">
                              {{translateLabel('columnDescription')}}
                            </th>
                            <th class="text-uppercase text-center" style="width: 10%; color:#000000">
                              {{translateLabel('software')}}
                            </th>
                            <th class="text-uppercase text-center" style="width: 10%; color:#000000">
                              {{translateLabel('hardware')}}
                            </th>
                            <th class="text-uppercase text-center" style="width: 10%; color:#000000">
                              {{translateLabel('service')}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="waitersCount > 0 || waiterSoftwareCount > 0">
                        <tr>
                          <td>{{translateLabel('waiter')}}</td>
                          <td class="text-center">{{waiterSoftwareCount}}</td>
                          <td class="text-center">{{waitersCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="cashRegisterPhoneCount + cashRegisterTabletCount > 0 || cashRegisterSoftwareCount > 0">
                        <tr>
                          <td>{{translateLabel('cashRegister')}}</td>
                          <td class="text-center">{{cashRegisterSoftwareCount}}</td>
                          <td class="text-center">{{cashRegisterPhoneCount + cashRegisterTabletCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="mainDevicePhoneCount + mainDeviceTabletCount > 0 || mainDeviceSoftwareCount > 0">
                        <tr>
                          <td>{{translateLabel('mainDevice')}}</td>
                          <td class="text-center">{{mainDeviceSoftwareCount}}</td>
                          <td class="text-center">{{mainDevicePhoneCount + mainDeviceTabletCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="noLicenseDevices > 0">
                        <tr>
                          <td>{{translateLabel('noLicenseDevices')}}</td>
                          <td class="text-center">-</td>
                          <td class="text-center">{{noLicenseDevices}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="waitersCount > 0 || cashRegisterPhoneCount > 0 || mainDevicePhoneCount > 0 || noLicenseDevices > 0">
                        <tr>
                          <td>{{translateLabel('phoneCharger')}}</td>
                          <td class="text-center">-</td>
                          <td class="text-center">
                            <input type="text" class="no-style; text-center" value="{{waitersCount + cashRegisterPhoneCount + mainDevicePhoneCount + noLicenseDevices}}"
                              style="margin-bottom: 0px; width: 40px" />
                          </td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="printerCount > 0 || printerSoftwareCount > 0">
                        <tr>
                          <td>{{translateLabel('printers')}}</td>
                          <td class="text-center">{{printerSoftwareCount}}</td>
                          <td class="text-center">{{printerCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="fiscalPrinterCount > 0 || fiscalPrinterSoftwareCount">
                        <tr>
                          <td>{{translateLabel('fiscalPrinter')}}</td>
                          <td class="text-center">{{fiscalPrinterSoftwareCount}}</td>
                          <td class="text-center">{{fiscalPrinterCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="printerCount > 0 || fiscalPrinterCount > 0">
                        <tr>
                          <td>{{translateLabel('printerCharger')}}</td>
                          <td class="text-center">-</td>
                          <td class="text-center">{{printerCount+fiscalPrinterCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container>
                        <tr *ngFor="let cable of cablesAmount">
                          @if (cable.amount > 0) {
                            <td>{{translateLabel('cable')}} {{cable.length}}m</td>
                            <td class="text-center">-</td>
                            <td class="text-center">{{cable.amount}}</td>
                            <td class="text-center">-</td>
                          }
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="routerCount > 0">
                        <tr>
                          <td>{{translateLabel('routers')}}</td>
                          <td class="text-center">-</td>
                          <td class="text-center">{{routerCount}}</td>
                          <td class="text-center">-</td>
                        </tr>
                      </ng-container>
                      <ng-container>
                        <tr *ngFor="let additionalCost of additionalCostsArray">
                          <ng-container *ngIf="additionalCost.id < 3 || additionalCost.id === 6 || additionalCost.id === 7 || additionalCost.id === 8 || additionalCost.id === 11">
                            <td>{{getadditionalCostLabel(additionalCost.name)}}</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">{{additionalCost.quantityRequested}}</td>
                          </ng-container>
                          <ng-container *ngIf="additionalCost.id === 3 || additionalCost.id === 4 || additionalCost.id === 5 || additionalCost.id === 12 || additionalCost.id === 14">
                            <td>{{getadditionalCostLabel(additionalCost.name)}}</td>
                            <td class="text-center">-</td>
                            <td class="text-center">{{additionalCost.quantityRequested}}</td>
                            <td class="text-center">-</td>
                          </ng-container>
                          <ng-container *ngIf="additionalCost.id === 9 || additionalCost.id === 10 || additionalCost.id === 13">
                            <td>{{getadditionalCostLabel(additionalCost.name)}}</td>
                            <td class="text-center">{{additionalCost.quantityRequested}}</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </tbody>
                </table>
                <div class="row mb-3">
                  <div class="col">
                    <div class="class border">
                      <div class="card-body text-uppercase" style="font-weight: bold;">
                        {{translateLabel('notes')}}
                        <textarea class="form-control" rows="5"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="hasHardware" style="page-break-inside: avoid">
                  <div style="display: flex; flex-direction: row">
                    <div class="class border" style="padding: 10px; width: 70%">
                      <strong class="text-uppercase" style="display: block;">{{translateLabel('transportTitle')}}:</strong><br />
                        <div class="form-check form-check-inline" style="margin-right: 40px;">
                          <input class="form-check-input" type="checkbox" id="absender"
                            [checked]="!event.delivery" [disabled]="true">
                          <label class="form-check-label text-uppercase" for="absender"
                            style="color: #212529 !important;">{{translateLabel('pickupOurOffice')}}</label>
                        </div>
                        <div class="form-check form-check-inline" style="margin-right: 40px;">
                          <input class="form-check-input" type="checkbox" id="lieferfirma"
                            [checked]="event.delivery" [disabled]="true">
                            <label class="form-check-label text-uppercase" for="lieferfirma"
                              style="color: #212529 !important;">{{translateLabel('sendByPost')}}</label>
                        </div>
                        <hr />
                        <ng-container *ngIf="event.delivery; else pickupPointTemplate">
                          <p class="text-center" style="font-size: 0.75rem !important;">
                            <strong>{{deliveryAddress?.firstLastName}}</strong><br />
                              {{deliveryAddress?.address}}<br />
                              {{deliveryAddress?.postcode}} {{deliveryAddress?.city}}<br />
                              {{deliveryAddress?.country.name}}<br />
                          </p>
                          </ng-container>
                          <ng-template #pickupPointTemplate>
                            <p class="text-center" style="font-size: 0.75rem !important;">
                              <strong>{{pickupPoint?.nameLangKey | translate}}</strong> <br />
                                {{pickupPoint?.addressLangKey | translate}} <br />
                                {{pickupPoint?.postCode}} {{pickupPoint?.cityLangKey | translate}}
                              <br />
                              {{pickupPoint?.country.name}}
                        </p>
                      </ng-template>
                    </div>
                    <div class="class border" style="padding: 10px; width: 30%">
                      <strong class="text-uppercase">{{translateLabel('transportDate')}}</strong>
                      <input type="text" style="width: 100%;" />
                    </div>
                  </div>
                  <div class="class border" style="width: 100%; height: 70px; vertical-align: initial; padding: 10px">
                    <strong class="text-uppercase">{{translateLabel('signatureCustomer')}}</strong>
                  </div>
                  <div class="class border" style="width: 100%; height: 70px; vertical-align: initial; padding: 10px">
                    <strong class="text-uppercase">{{translateLabel('signatureSupplier')}}</strong>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div data-size="A4" id="draftPdfPreview2" class="mt-5">
        <div class="row">
            <div class="col" style="padding: 0px;">
                <ng-container *ngIf="event.routers && event.routers.length > 0">
                  <table class="table table-bordered">
                    <thead>
                        <th>Router Name</th>
                        <th>Network Name</th>
                        <th>Network Password</th>
                        <th>Router Type</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let router of event.routers"
                            style="page-break-inside: avoid; page-break-after: auto">
                            <td>{{router.name}}</td>
                            <td>{{router.networkName}}</td>
                            <td>{{router.networkPassword}}</td>
                            <td style="vertical-align: top;">
                                <input type="text" style="width: 100%;" />
                            </td>
                        </tr>
                    </tbody>
                  </table>
                  <div class="col">
                      <hr>
                  </div>
                </ng-container>
                <ng-container *ngIf="event.printers && event.printers?.length > 0">
                  <table class="table table-bordered">
                    <thead>
                        <th>Printer Name</th>
                        <th>Printer Category</th>
                        <th>Device Name</th>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let rec of printCategoriesDeliveryPaperArray">
                                <td>
                                    {{rec.printerName}}
                                </td>
                                <td>
                                    {{rec.categoryName}}
                                </td>
                                <td>
                                    {{rec.deviceName}}
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                  </table>
                  <div class="col">
                      <hr>
                  </div>
                </ng-container>
                <table class="table table-bordered" style="font-size: 11px;">
                    <thead style="text-align: center;">
                        <th>Name</th>
                        <th>Role</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th>PIN Code</th>
                        <th>Device Name</th>
                        <th *ngIf="showPayment">Show Payment</th>
                        <th *ngIf="showSales">Show Sales</th>
                        <th *ngIf="showDoublePrint">Double Print</th>
                        <th *ngIf="showDisablePrint">Disable Print</th>
                        <th *ngIf="showSumUp">SumUp</th>
                        <th *ngIf="showVivaWallet">VivaWallet</th>
                        <th *ngIf="showFiscalPrinter">Fiscal Printer</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let deviceUser of event.deviceUsers"
                            style="page-break-inside: avoid; page-break-after: auto">
                            <td>{{deviceUser.name}}</td>
                            <td><ng-container *ngIf="deviceUser && deviceUser.deviceUserType ">
                              <ng-container>{{deviceUser.deviceUserType.name}}</ng-container>
                            </ng-container></td>
                            <td><ng-container *ngIf="deviceUser">{{deviceUser.username}}</ng-container></td>
                            <td><ng-container *ngIf="deviceUser">{{deviceUser.pinCode}}</ng-container></td>
                            <td><ng-container *ngIf="deviceUser">{{deviceUser.lvlOnePin}}</ng-container></td>
                            <td><ng-container *ngIf="deviceUser">{{ (!deviceUser.device) ? 'Not Assigned' : deviceUser.device.name }}</ng-container></td>
                            <td *ngIf="showPayment" style="text-align: center; "><ng-container>{{deviceUser.enablePaymentScreen ? '✓': 'X'}}</ng-container></td>
                            <td *ngIf="showSales" style="text-align: center;"><ng-container>{{deviceUser.showSales ? '✓' : 'X'}}</ng-container></td>
                            <td *ngIf="showDoublePrint" style="text-align: center;"><ng-container>{{deviceUser.enableDoublePrint ? '✓' : 'X'}}</ng-container></td>
                            <td *ngIf="showDisablePrint" style="text-align: center;"><ng-container>{{deviceUser.paidWithoutPrint ? '✓' : 'X'}}</ng-container></td>
                            <td *ngIf="showSumUp" style="text-align: center;"><ng-container>{{deviceUser.enableSumUp ? '✓' : 'X'}}</ng-container></td>
                            <td *ngIf="showVivaWallet" style="text-align: center;"><ng-container>{{deviceUser.enableVivaWallet ? '✓' : 'X'}}</ng-container></td>
                            <td *ngIf="showWorldLine" style="text-align: center"><ng-container>{{deviceUser.enableWorldLine ? '✓' : 'X'}}</ng-container></td>
                            <td *ngIf="showFiscalPrinter" style="text-align: center;"><ng-container>{{deviceUser.hasFiscalPrinter ? '✓' : 'X'}}</ng-container></td>
                        </tr>
                    </tbody>
                </table>
                <div style="text-align: center; margin-top: 20px; font-weight: bold; font-size: large">{{translateLabel('qrCodes')}}</div>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; gap: 30px">
                  <div *ngFor="let deviceUser of event.deviceUsers" style="break-inside: avoid; page-break-inside: avoid; padding-top: 20px">
                    <div style="border:#000000 1px solid;">
                      <div style="text-align: center; font-weight: bold; font-size: medium">{{deviceUser.name}}</div>
                      <div>
                        <qrcode [qrdata]="'famulusapp://rudi.com/du?a=' + deviceUser.username + '&b=' + deviceUser.pinCode" [width]="180"></qrcode>
                      </div>
                    </div>
                  </div>
                </div>
                <blockquote class="blockquote mt-5">
                    <h4 class="mb-0 mt-0 text-center" [innerHTML]="translateLabel('warningMessage')"></h4>
                </blockquote>
                <blockquote class="blockquote mt-5">
                  <h4 class="mb-0 mt-0 text-center" [innerHTML]="translateLabel('videoQrCodeMessage')"></h4>
                  <img src="../../../../assets/img/{{translateLabel('videoQrCodeLink')}}" style="display:block; width:100px;height: auto; margin:0 auto;"/>
                </blockquote>
            </div>
        </div>
    </div>
</div>
